import { useSelector } from 'react-redux';
import { STATUS } from '../../shared/enums';
import {
  selectRegionalPricesData,
  selectRegionalPricesStatus,
} from '../features/regionalPrices/regionalPricesSlice';
import { getHeaderUnitPrices } from '../features/regionalPrices/regionalPricesHelpers';
import filterRegionSpecificPrices from '../static-data/filterRegionSpecificPrices';

const useHeaderPrices = regional => {
  const regionalPrices = useSelector(selectRegionalPricesData);
  const status = useSelector(selectRegionalPricesStatus);
  const isLoaded = [ STATUS.PREFETCHED, STATUS.SUCCEEDED ].includes(status);

  return getHeaderUnitPrices(
    isLoaded ? regionalPrices : null,
    regional,
    filterRegionSpecificPrices,
  );
};

export default useHeaderPrices;
